<template>
  <ul class="tw-grid tw-grid-cols-1 tw-gap-sm md:tw-grid-cols-2">
    <SpotifyPlaylistDisplayElement
      v-for="(spotifyPlaylistId, index) in displayedPlayListUrls"
      :key="index"
      html-tag="li"
      :spotify-playlist-id="spotifyPlaylistId"
      small
      class="tw-flex tw-flex-wrap tw-items-center tw-overflow-hidden"
      @iframe-click="handleIframeClick"
    >
      <template #default="{ playlistInfos }">
        <NuxtLinkLocale
          :to="{
            path: `/spotify/playlist/${spotifyPlaylistId}`,
            query: {
              slug: $route.params.slug,
              draftId: $route.query.draftId,
            },
          }"
          class="gradientLink tw-loading-gradient tw-mt-2 tw-flex tw-h-8 tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-space-x-1 tw-rounded-xl tw-bg-gradient-to-r tw-from-black tw-to-gray-500 tw-p-2 md:tw-p-2 lg:tw-h-10 lg:tw-p-4"
          :aria-label="$t('components.spotify.displayPlaylist.aria.label.link')"
        >
          <span v-if="playlistInfos && playlistInfos.followers">
            <i class="fa-solid fa-heart tw-text-white" />
            <VText cfg="sans/14/medium" color="white" aria-hidden>{{
              $t(
                'components.influencer.profile.SpotifyPlaylistDisplayCollection.cta.likes',
                { count: formatNumber(playlistInfos.followers) },
              )
            }}</VText>
            <VText cfg="sans/14/medium" color="white" aria-hidden>·</VText>
          </span>
          <VText cfg="sans/14/medium" color="orange-400" aria-hidden>{{
            $t('common.seeinfo')
          }}</VText>
        </NuxtLinkLocale>
      </template>
    </SpotifyPlaylistDisplayElement>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SpotifyPlaylistDisplayElement from '~/components/spotify/SpotifyPlaylistDisplayElement.vue'
import VText from '~/components/ui/VText.vue'

import SegmentMixin from '~/mixins/Segment/Segment'

import type { SpotifyPlaylistDetails } from '~/types/spotify-core-api'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    VText,
    SpotifyPlaylistDisplayElement,
  },
  mixins: [SegmentMixin],
  props: {
    spotifyPlaylists: {
      type: Array as PropType<{ spotify_id: string }[]>,
      required: true,
    },
  },
  setup() {
    const localePath = useLocalePath()

    return {
      localePath,
    }
  },
  data() {
    return {
      detailArray: [] as SpotifyPlaylistDetails[],
      mouseEnterLatch: false,
    }
  },
  computed: {
    displayedPlayListUrls(): string[] {
      return this.spotifyPlaylists.map(
        ({ spotify_id }: { spotify_id: string }) => spotify_id,
      )
    },
  },
  methods: {
    trackMouseEnter(): void {
      if (this.mouseEnterLatch) return

      this.mouseEnterLatch = true
      this.trackSegmentEvent('Curator Profile - Playlist Display Hovered', {})
    },
    handleIframeClick(): void {
      this.trackSegmentEvent('Curator Profile - Spotify Player Clicked', {})
    },
  },
})
</script>

<style lang="scss" scoped>
.gradientLink {
  @apply tw-from-[#282828] tw-to-[#282828ee];
}
</style>
